webpackJsonp([399],{

/***/ 1771:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(2222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/thanks-34.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] thanks-34.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4bd086e6", Component.options)
  } else {
    hotAPI.reload("data-v-4bd086e6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2222:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Thanks")]), _vm._v(" "), _c('h2', [_vm._v("VUX 参考或者使用了以下开源项目的代码")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue"
    }
  }, [_vm._v("Vue")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/weui/weui"
    }
  }, [_vm._v("WeUI")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/frozenui/frozenui"
    }
  }, [_vm._v("FrozenUI")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/ant-design/ant-design"
    }
  }, [_vm._v("Ant Design")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://github.com/ant-design/ant-design-mobile"
    }
  }, [_vm._v("Ant Design Mobile")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/huxiaoqi567/xscroll"
    }
  }, [_vm._v("XScroll")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/driftyco/ionic"
    }
  }, [_vm._v("Ionic")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/sdc-alibaba/SUI-Mobile"
    }
  }, [_vm._v("SUI Mobile")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/dimsemenov/PhotoSwipe"
    }
  }, [_vm._v("PhotoSwipe")])])]), _vm._v(" "), _c('h2', [_vm._v("工具框架")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("世界上最好的语言 "), _c('code', [_vm._v("JavaScript")])]), _vm._v(" "), _c('li', [_vm._v("啥都能做的前端构建工具 "), _c('a', {
    attrs: {
      "href": "https://webpack.js.org/"
    }
  }, [_vm._v("Webpack")])]), _vm._v(" "), _c('li', [_vm._v("简单好用的文档展示工具 "), _c('a', {
    attrs: {
      "href": "https://docute.js.org/#/"
    }
  }, [_vm._v("Docute")])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4bd086e6", module.exports)
  }
}

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1771);

/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "感谢 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 399.762ee18e.js